import React from "react";
import styled from "styled-components";

interface StyledIconProps {
  size: "large" | "small";
}

const StyledIcon = styled.img<StyledIconProps>`
  max-height: 125px;
  max-width: 100%;
  object-fit: contain;
`;

function Icon({
  icon = "",
  description = "",
  size = "small",
}: {
  icon?: string;
  description?: string;
  size?: "large" | "small";
}) {
  return <StyledIcon size={size} src={icon} alt={`${description} icon`} />;
}

export default Icon;
